import React, { useState } from 'react';
import ReactTooltip from 'react-tooltip';
import { Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const Nuova_domanda = (props) => {
    const [somma, calcola_somma] = useState('');


    const Crea_nuova_domanda = () => {
        var lista_aux = props.lista_file_mp3
        var difficolta_iniziale = 10
        var sottrazione = difficolta_iniziale - props.valore_minimo_sottrazione + 1
        lista_aux.push({ indice_aux: sottrazione, indice_end: difficolta_iniziale, materia: 'new', n_r: 'undefined', n_q: 'undefined', risposta: '<p> insert </p>' })
        props.SET_lista_file_mp3(lista_aux)
        props.SET_aggiorna_lista(2)
        console.log('OOOOOOOOOOOOOOOOOOOOO')
        console.log('indice_aux ' + sottrazione)
        console.log('props.valore_minimo_sottrazione ' + props.valore_minimo_sottrazione)

    }


    return (
        <div>

            <Button variant="primary" onClick={Crea_nuova_domanda}>Nuova domanda</Button>
            {'N domande totali: ' + props.lista_file_mp3.length}
            {' - N domande scelte: ' + props.play_lista.length}
            {' - Minimo ' + props.valore_minimo_sottrazione}



        </div>
    )
}

export default Nuova_domanda;
